import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import * as Moment from 'moment';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

function today() {
  return Moment().format('MM/DD/YYYY');
}

@Component({
  selector: 'app-from-to-date-range-selector',
  templateUrl: './from-to-date-range-selector.component.html',
  styleUrls: ['./from-to-date-range-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FromToDateRangeSelectorComponent implements OnInit, OnDestroy {

  @Input() public startGroupControl?: UntypedFormControl;
  @Input() public endGroupControl?: UntypedFormControl;
  private onDestroy$: Subject<void> = new Subject<void>();

  public startDate: string | number | Date | undefined = new Date();
  public endDate: string | number | Date | undefined = new Date();

  constructor(private renderer: Renderer2, private ref: ChangeDetectorRef) {  }

  public handleChanges(value: Date, control?: UntypedFormControl) {
    control?.setValue(value);
  }

  public ngOnInit(): void {
    this.startGroupControl?.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe((value) => {
      if (value === today() || value === undefined || value === null) {
        this.startDate = new Date();
      }
      this.ref.detectChanges();
    });

    this.endGroupControl?.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe((value) => {
      if (value === undefined || value === null) {
        this.endDate = new Date();
      }
      this.ref.detectChanges();
    });
  }

  public onContentReady(e: any) {
    const element = e.element;
    if (e.component._pickerType === 'native') {
      const button = element.querySelector('.dx-texteditor-buttons-container');
      const input = element.querySelector('.dx-texteditor-input');
      this.renderer.setStyle(button, 'display', 'none');
      this.renderer.setStyle(input, 'padding-right', '5px');
    }
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete()
  }
}
